export default {
  new_employee: 'Add new employee',
  btn_cancel: 'Cancel',
  btn_add: 'Add',
  first_name: 'First name',
  first_name_placeholder: 'Enter your first name',
  last_name: 'Last name',
  last_name_placeholder: 'Enter your first name',
  email: 'Email address',
  email_placeholder: 'Enter your email',
  internal_id: 'Internal ID',
  internal_id_placeholder: 'Enter your internal ID',
  phone: 'Phone',
  phone_placeholder: 'Enter your phone',
  workplace: 'Workplace',
  workplace_placeholder: 'Enter workplace',
  vacation_days: 'Vacation hours',
  vacation_placeholder: 'Enter vacation hours',
  private_car: 'Private car',
  private_placeholder: 'Enter licence plate',
  company_car: 'Company car',
  company_placeholder: 'Enter licence plate',
  rental_car: 'Rental car',
  role: 'Role',
  substitution: 'Substitution (optional)',
  substitution_manager: 'Substitution',
  substitution_placeholder: 'Enter substitution',
  add_substitution: '+ Add one more substitution',
  add_private_car: '+ Add one more private car',
  rate: 'Mileage rate',
  rate_placeholder: 'Choose type of rate',
  area: 'Area',
  area_placeholder: 'Enter area',
  area_manager: 'Area(s)',
  add_area: '+ Add one more area',
  area_manager_text: 'Area manager',
  work_log: 'Work log',
  work_calendar: 'Work calendar',
  km_log: 'Kilometer Log',
  add_km: 'Add KM Reading',
  add_reading: 'Add Monthly Mileage Reading',
  choose_month: 'Choose Month',
  mileage: 'End of Month Mileage',
  enter_mileage: 'Enter End of month mileage',
  upload_photo: 'Upload Mileage Photo',
  error_format: 'Only JPG and PNG files are allowed.',
  error_size: 'File size must be less than 20MB.',
  upload_drag: 'Drag file here or',
  upload_click: 'click to upload',
  upload_tip: 'You can upload only 1 jpg/png file with a size less than 20MB.',
  upload: 'Upload',
  km_end: 'KM-End',
  vacation: 'Vacation',
  type_employee: 'Type of employee',
  phone_number: 'Phone number',
  password: 'Password',
  change: 'Change',
  info: {
    id: 'ID',
    area: 'Area',
    rate: 'Mileage rate',
    email: 'Email',
    supervisor: 'Supervisor',
    substitute: 'Substitute',
    phone: 'Phone',
    remaining: 'Remaining leave:',
    requested: 'Requested leave:',
    admin: 'CEO',
    manager: 'Head of Area Management',
    hours: 'Hours',
  },
  is_deleted: 'is deleted',
  deactivate_text: 'Do you wnat to deactivate user?',
  activate_text: 'Do you wnat to activate user?',
  working_days: 'working days',
  days_off: 'days off',
  set_up_working_hours: 'Please, Set up working hours',
  choose_working_day: 'Please, choose a working day and set up time',
  vacation_day: 'Vacation Day',
  sick_leave: 'Sick leave',
  flextime: 'Flextime',
  national_holiday: 'National holiday',
  other: 'Other',
  days: {
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    sunday: 'sunday',
  },
  rolling_days: {
    day_1: 'Day 1',
    day_2: 'Day 2',
    day_3: 'Day 3',
    day_4: 'Day 4',
  },
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  // kWh  
  has_electric_vehicle: 'Has Electric Vehicle',
  kwh_log: 'kWh Log',
  month: 'Month',
  kwh: 'kWh',
  km: 'km',
  delete_kwh_log_text: 'Do you want to delete kWh Log from system?',
  add_kwh: 'Add kWh Reading',
  add_kwh_reading: 'Add monthly kWh reading',
  kwh_value: 'Monthly kWh usage',
  enter_kwh_value: 'Enter Monthly kWh usage',
  upload_kwh_photo: 'Upload Monthly kWh usage photo',
  profile: {
    settings: 'Settings',
    kwh_price: 'kWh Price',
    euro_per_kwh: '€/kWh',
    price_label: 'Price, €/kWh',
    save: 'Save'
  }
}
